module.exports = __webpack_public_path__ + "img/dongtai_pic.bfac4d1b.png";